module.exports = __webpack_public_path__ + "static/media/IMG_1321.af74c2c6.jpg";